module.exports = __webpack_public_path__ + "static/default-c134834eedbf0175a88c2411eac0a2c9.jpg";